export const isSafari = () => {
  const ua = navigator.userAgent.toLowerCase();

  if (ua.includes('safari')) {
    return !ua.includes('chrome');
  }

  return false;
};
